/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetGoogleLoginUrlResponse
 */
export interface GetGoogleLoginUrlResponse {
    /**
     * 
     */
    url: string;
}

/**
 * Check if a given object implements the GetGoogleLoginUrlResponse interface.
 */
export function instanceOfGetGoogleLoginUrlResponse(value: object): value is GetGoogleLoginUrlResponse {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function GetGoogleLoginUrlResponseFromJSON(json: any): GetGoogleLoginUrlResponse {
    return GetGoogleLoginUrlResponseFromJSONTyped(json, false);
}

export function GetGoogleLoginUrlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetGoogleLoginUrlResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function GetGoogleLoginUrlResponseToJSON(json: any): GetGoogleLoginUrlResponse {
    return GetGoogleLoginUrlResponseToJSONTyped(json, false);
}

export function GetGoogleLoginUrlResponseToJSONTyped(value?: GetGoogleLoginUrlResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

